import React from "react";
import { FormControl } from "react-bootstrap";

function TextInput(
    props: { onChange: React.FormEventHandler<FormControl> } & { [k: string]: any },
    ref: React.ForwardedRef<HTMLInputElement>
) {
    return <FormControl type="text" {...props} inputRef={typeof ref === "function" ? ref : undefined} />;
}

export default React.forwardRef(TextInput);
